export const formatWhatsApp = (phoneNumber: string) => {
  if (phoneNumber.charAt(0) === "0") {
    phoneNumber = phoneNumber.slice(1);
  }
  phoneNumber = "+93" + phoneNumber;

  return phoneNumber;
};
